import { render } from "./LeftSideItem.vue?vue&type=template&id=1d64d0e6&scoped=true"
import script from "./LeftSideItem.vue?vue&type=script&lang=js"
export * from "./LeftSideItem.vue?vue&type=script&lang=js"

import "./LeftSideItem.vue?vue&type=style&index=0&id=1d64d0e6&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d64d0e6"]])

export default __exports__